import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import {
  IMAGE_FORMAT_FILES_NOT_ALLOWED,
  MAX_SIZE_FILE,
  MSWORD_FORMAT_FILES_NOT_ALLOWED,
  OPENXML_FORMAT_FILES_NOT_ALLOWED,
  TYPE_FILE_ALLOWED,
} from '@app/@core/constants/requests.constants';
import { FileUpload } from '@app/requests/model/requests-model';
import { DocumentationUploadService } from '@app/requests/update-documentation/update-documentation.service';

@Component({
  selector: 'scf-update',
  templateUrl: './update.component.html',
  styleUrls: ['./update.component.scss'],
})
export class UpdateComponent implements OnInit {
  @Input() numFile: number;
  @Output() saveFile = new EventEmitter<FileUpload>();
  @ViewChild('description') descriptionElement: ElementRef;

  srcResult: string;
  iconCircle: string;
  fileUpload: File;
  nameFile: string;
  loadFile: boolean = false;
  validationError: boolean = false;
  description: string = '';

  constructor(private documentationUploadService: DocumentationUploadService) {}

  ngOnInit(): void {
    this.iconCircle = 'check_circle';
    console.log(this.numFile);

    this.documentationUploadService.getResetUploadFile().subscribe((resp: boolean) => {
      if (resp) {
        this.fileUpload = null;
        this.loadFile = false;
        this.nameFile = null;
      }
    });
  }

  selectFile(event: any): void {
    this.fileUpload = event.target.files[0];
    console.log(this.fileUpload);
    if (this.fileUpload) {
      const fileName = this.fileUpload.name;
      //validation of size
      if (this.fileUpload.size <= 0 || this.fileUpload.size > MAX_SIZE_FILE) {
        this.validationError = true;
        this.nameFile = 'El formato o peso del archivo no es válido';
        this.iconCircle = 'cancel';
        this.saveFile.emit({
          numFile: this.numFile,
          file: this.fileUpload,
          description: this.description,
          error: true,
        });
      } else if (
        !TYPE_FILE_ALLOWED.includes(this.fileUpload.type) ||
        (TYPE_FILE_ALLOWED.includes(this.fileUpload.type) &&
          (IMAGE_FORMAT_FILES_NOT_ALLOWED.includes(fileName.substring(fileName.lastIndexOf('.'), fileName.length)) ||
            MSWORD_FORMAT_FILES_NOT_ALLOWED.includes(fileName.substring(fileName.lastIndexOf('.'), fileName.length)) ||
            OPENXML_FORMAT_FILES_NOT_ALLOWED.includes(fileName.substring(fileName.lastIndexOf('.'), fileName.length))))
      ) {
        this.validationError = true;
        this.nameFile = 'El formato del archivo no es válido';
        this.iconCircle = 'cancel';
        this.saveFile.emit({
          numFile: this.numFile,
          file: this.fileUpload,
          description: this.description,
          error: true,
        });
      } else {
        this.validationError = false;
        this.iconCircle = 'check_circle';
        this.loadFile = true;
        this.nameFile = event.target.files[0].name;
        this.saveFile.emit({ numFile: this.numFile, file: this.fileUpload, description: this.description });
      }
    } else {
      this.loadFile = false;
      this.saveFile.emit({ numFile: this.numFile, file: this.fileUpload, description: this.description });
      this.descriptionElement.nativeElement.value = '';
    }
  }

  getDescription(value: any) {
    this.description = value;
    if (!this.validationError)
      this.saveFile.emit({ numFile: this.numFile, file: this.fileUpload, description: this.description });
  }

  onFileSelected() {
    const inputNode: any = document.querySelector('#file');

    if (typeof FileReader !== 'undefined') {
      const reader = new FileReader();

      reader.onload = (e: any) => {
        this.srcResult = e.target.result;
      };

      reader.readAsArrayBuffer(inputNode.files[0]);
    }
  }
}
